import { Injectable } from '@angular/core';
import { PromoPage } from '@app/pages/promo/promo.page';
import { ModalController } from '@ionic/angular';
import { ParseService } from '@services/api/parse/parse.service';
import { UserStoreService } from '@services/api/user-store/user-store.service';
import { StorageService } from '@services/storage/storage.service';
import { BehaviorSubject } from 'rxjs';

const KEY_POINTS = 'OFFER_CREDIT_POINTS';
const KEY_OFFER_SETTINGS = 'OFFER_SETTINGS';
const KEY_COUNTDOWN = 'OFFER_COUNTDOWN';

@Injectable({
  providedIn: 'root'
})
export class OfferService {
  private isOfferActiveAndFreemium: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    private storageService: StorageService,
    private parseService: ParseService,
    private modalCtrl: ModalController,
    private userStoreService: UserStoreService
  ) {}

  async init() {
    this.refreshOfferSettings();

  }

  getShowPromo()  {
    return this.isOfferActiveAndFreemium;
  }

  async readOffersSettings() {
    let offerSettings = await this.storageService.get(KEY_OFFER_SETTINGS);
    if (!offerSettings) {
      offerSettings = await this.refreshOfferSettings();
    }

    return offerSettings;
  }

  private async refreshOfferSettings() {
    try {
      const user = await this.userStoreService.getUser();
      if(!user) {
          return;
      }

      if (!this.userStoreService.userIsFreemium()) {
        return;
      }
      const offer = await this.parseService.run('fetchOffersSettings', { offerName: '20_off' });
      await this.storageService.set(KEY_OFFER_SETTINGS, offer);

      const countdownDate = await this.storageService.get(KEY_COUNTDOWN);
      if (!countdownDate || new Date(countdownDate) < new Date()) {
        const countdown = new Date();
        countdown.setHours(countdown.getHours()  + 24);   
        this.storageService.set(KEY_COUNTDOWN, countdown);
      } 

      await this.setIsOfferActiveAndFreemium();

      return offer;
    } catch (e) {
      console.log(e);
    }
  }

  async readCountDownDate() {
    const countdownDate = await this.storageService.get(KEY_COUNTDOWN);
    return new Date(countdownDate);
  }

  private async initBalance() {
    await this.storageService.set(KEY_POINTS, 0);
  }

  private async getBalance() {
    const balance = await this.storageService.get(KEY_POINTS);

    if (typeof balance != 'number') {
      await this.initBalance();
    }

    return balance ?? 0;
  }

  async addPoint() {
    if (!this.userStoreService.userIsFreemium()) {
      return;
    }

    let points = await this.getBalance();
    points = points + 1;
    await this.storageService.set(KEY_POINTS, points);
    if (points === 2 || points % 5 === 0) {
      this.openPromo();
    }
    this.refreshOfferSettings();
  }

  async isOfferActive() {
    const offerSettings = await this.readOffersSettings();
    const isActive = offerSettings?.status === 'ACTIVE';
    return isActive;
  }

  async openPromo() {
    const modal = await this.modalCtrl.create({
      component: PromoPage,
      cssClass: 'fullscreen'
    });
    modal.present();
  }

  async setIsOfferActiveAndFreemium() {
    const countdownDate = await this.readCountDownDate();
    const isCountdownDateValidate = countdownDate && countdownDate > new Date();
    const isFreemium = this.userStoreService.userIsFreemium();
    const isOfferActive = await this.isOfferActive()
    const points = await this.getBalance();
    const aux = isOfferActive && isFreemium && isCountdownDateValidate && points >= 2;
    this.isOfferActiveAndFreemium.next(aux);
  }
}
